import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import TranslationLabelsCacheName from "../../utils/TranslationLabelsCacheName";
import { bulkValidateLabels } from "../../api/bulkValidateLabels";
import { showReportToast } from "../../components/ui/ReportToast";

export function useBulkValidateLabels(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: bulkValidateLabels,
    onSuccess: (report) => {
      showReportToast({
        title: "Validation done",
        counts: { validated: report.validated, skipped: report.skipped, rejected: report.rejected },
        rows: report.labels,
        successStatus: "validated",
        fileName: "validation-report.csv",
      });
      queryClient.invalidateQueries(TranslationLabelsCacheName.getLibelleList());

      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: AxiosError) => {
      const errorMessage = ErrorUtils.getErrorMessage(error);
      toast.error(errorMessage, {
        autoClose: false,
      });
    },
  });
}
